import { makeObservable, observable } from "mobx";
import DefectData from "./defectData";
import { authStore } from "../store/authStore";
import { FilterItem } from "../api/Types";
import { FilterCondition } from "../constants/Enums";
import { ExpandableKeys } from "./core";

class AgreementPlanedDefectData extends DefectData {
  filterItems: FilterItem[] = [
    {
      fieldName: "isValid",
      value: true,
      condition: FilterCondition.Equal,
    },
    {
      fieldName: "eventTypeId",
      value: 3,
      condition: FilterCondition.Equal,
    },
    {
      fieldName: "incidentStatusId",
      value: 0,
      valueTo: 6,
      condition: FilterCondition.Between,
    },
  ];
  selectedRows = new ExpandableKeys();
  constructor() {
    super();
    this.dataLable = "Согласованные плановые";
    makeObservable(
      this,
      {
        selectedRows: observable,
      }
    )
  }
}

const agreementPlanedDefectDataStore = new AgreementPlanedDefectData();
export default agreementPlanedDefectDataStore;